import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableBody';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import '../../assets/style/style.css';
import { useMaterialUIController, setOrderContext } from "context";
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";
function UnfulfillmentList(props) {
  const [controller, dispatch] = useMaterialUIController();
  const { orderContext }       = controller;  
  const { t }                  = useTranslation();
  const orderID                = props.orderID;
  const orderStatus            = props.orderStatus;
  const unfulfilledDetails     = orderContext.unfulfilledTableData;
  return (
            <>
              {unfulfilledDetails.unfulfilledRows && unfulfilledDetails.unfulfilledRows.length > 0 ?
                <Grid item xs={12}>
                  <Card variant="outlined">
                    <Grid item xs={12}>
                      <Grid container spacing={0}>
                        <Grid item sm={6} xs={12} px={2} py={2} display="flex">                       
                          <Box sx={{ border: '1px dashed grey', width: 'fit-content' }} px={1}>
                            { (orderStatus === 'rejected') ?
                              <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} gutterBottom>
                                  {t("Order Rejected")}
                              </Typography>
                            : 
                              <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} gutterBottom>
                                      {t('Unfulfilled Products')} : {unfulfilledDetails.unfulfilledProductsCount}
                              </Typography>
                            }                            
                          </Box>
                        </Grid>
                        <Grid item sm={6} xs={12} px={2} py={2} display="flex" justifyContent="flex-end">                       
                          <Box sx={{ border: '1px dashed grey', width: 'fit-content' }} px={1}>
                            <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} gutterBottom>
                                {t('Total No. of products ordered')} : {unfulfilledDetails.totalOrderedProducts}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      <TableContainer>
                        <Table>
                          <TableHead key={1}>
                            <TableRow key={1}> 
                              {unfulfilledDetails.unfulfilledColumns.map((column, index) => (
                                <TableCell key={"key-"+index}>{column.label}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead> 
                          <TableBody key={2}>
                            {unfulfilledDetails.unfulfilledRows.map((row, index) => (
                              <TableRow key={index}>
                                {unfulfilledDetails.unfulfilledColumns.map((column) => (
                                  <TableCell key={column.field+'-'+index}>   
                                    {row[column.field]}
                                  </TableCell>
                                ))}
                              </TableRow>
                              ))}
                          </TableBody>    
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Card> 
                </Grid>
              : <></>}   
          </>                       
        );
}
export default UnfulfillmentList;
